import { authClient } from '../lib/auth-client';
import { apiClient } from '../lib/api';
import {
	ApiResponseSchema,
	ForgotPasswordResponseSchema,
	LoginRequest,
	type ForgotPasswordResponse,
} from '../schemas';

export const authApi = {
	/** Public endpoint: sends a reset OTP to the account's email. */
	forgotPassword: async (identifier: string): Promise<ForgotPasswordResponse> => {
		const res = await apiClient.post<unknown>('/password/forgot', { identifier });
		return ApiResponseSchema(ForgotPasswordResponseSchema).parse(res.data).data;
	},

	// Sign in using Better Auth
	signIn: async (data: LoginRequest) => {
		const response = await authClient.signIn.email({
			email: data.email,
			password: data.password,
			rememberMe: data.rememberMe || false
		});

		if (response.error) {
			throw new Error(response.error.message || 'Đăng nhập thất bại');
		}

		return response.data;
	},

	// Sign out using Better Auth
	signOut: async () => {
		const response = await authClient.signOut();

		if (response.error) {
			throw new Error(response.error.message || 'Đăng xuất thất bại');
		}

		return { success: true };
	},

	// Get current session using Better Auth
	getSession: async () => {
		const response = await authClient.getSession();

		if (response.error) {
			throw new Error(response.error.message || 'Không thể lấy session');
		}

		return response.data;
	},


};